import Head from 'next/head';
import { Hero, Timer, Packages, Extras, GeoCoverage, Timeline, Offer } from '../../components/worldCup/sections';

const WorldCup2026 = props => {
  return (
    <div>
      <Hero />
      <Timer />
      <Packages />
      <Extras />
      <GeoCoverage />
      <Timeline />
      <Offer />
    </div>
  );
};

export default WorldCup2026;
